import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoadingSpinner = ({ text = "Loading..." }) => {
  return (
    <div 
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '200px',
        gap: '10px'
      }}
    >
      <Spinner 
        animation="border" 
        role="status" 
        style={{ color: 'var(--brand-primary-medium)' }}
      >
        <span className="visually-hidden">Loading...</span>
      </Spinner>
      <div style={{ color: '#6c757d', fontStyle: 'italic' }}>
        {text}
      </div>
    </div>
  );
};

export default LoadingSpinner; 